import { Behavior } from '../Behavior';
import { TaskStatus } from '../TaskStatus';
/**
 * 简单的任务，它将输出指定的文本并返回成功。 它可以用于调试。
 */
export class LogAction extends Behavior {
    constructor(text) {
        super();
        /** 是否输出error还是log */
        this.isError = false;
        this.text = text;
    }
    update(_context) {
        if (this.isError)
            console.error(this.text);
        else
            console.log(this.text);
        return TaskStatus.Success;
    }
}
//# sourceMappingURL=LogAction.js.map